/* src/app/features/contratacao/operacao/operacao-pesquisa.component.scss */
.botoes {
  display: flex;
  justify-content: right;
  align-items: center;
}
.letra-miuda {
  font-size: 15px;
  font-weight: bold;
  text-align: bottom;
  justify-content: flex-end;
  position: absolute;
}
#pesquisa_avancada {
  padding-left: 43px;
  padding-top: 9px;
}
.nowrap {
  white-space: nowrap;
}
.botoes .btn2 {
  margin: 4px;
}
.botoes .btn3 {
  margin: 4px;
}
.botoes .btn4 {
  margin: 4px;
}
@media screen and (max-width: 600px) {
  .mobile {
    display: none;
  }
  .desktop {
    font-size: 2.1vw;
  }
  .botaoMenor {
    width: 90%;
    height: 90%;
    font-size: 2vw;
    white-space: nowrap;
  }
  #pesquisa_avancada {
    padding-left: 35px;
    white-space: nowrap;
    padding-right: 50px;
    font-size: 12px;
  }
}
/*# sourceMappingURL=operacao-pesquisa.component.css.map */
